/**
 * Will create a PopUp modal to show
 * The PopUp could be personalized with the parameter below.
 *
 * @param     {string} title [The title of the PopUp, REQUIRED]
 * @param     {function} action [The action to trigger, REQUIRED]
 * @param     {ReactDOM} child [Description of the PopUp, would be the child, REQUIRED]
 * @param     {string} buttonText [The text of the button]
 * @param     {string} type [The type of PopUp: 'default' or 'success' or 'warning' or 'error'}]
 * @param     {boolean} overlay [Activates or not the background overlay: true or false]
 * @param     {function} secondaryAction [The action of the second button]
 * @param     {number} numberButtons [Number of buttons to set: 1 or 2]
 * @param     {string} secondaryButtonText [ The text of the second button]
 */

/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - CSS
 */
import './styles/PopUp.css'

export default class PopUp extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            title: props.title,
            description: props.children,
            buttonText: props.buttonText,
            secondaryButtonText: props.secondaryButtonText,
            thirdButtonText: props.thirdButtonText,
            fourthButtonText: props.fourthButtonText,
            type: (props.type) ?
                props.type :
                'default',
            overlay: (props.overlay) ?
                props.overlay :
                true,
            numberButtons: (props.numberButtons) ?
                props.numberButtons :
                ((props.secondaryButtonText) ?
                    2 :
                    1
                ),
        }
    }

    /**
     * This method will release the action of the first button setted by props
     */
    actionButton1 = () => this.props.action()

    /**
     * This method will release the action of the second button setted by props
     */
    actionButton2 = () => this.props.secondaryAction()

    /**
     * This method will release the action of the third button setted by props
     */
    actionButton3 = () => this.props.thirdAction()

    /**
     * This method will release the action of the fourth button setted by props
     */
    actionButton4 = () => this.props.fourthAction()

    /**
     * This function renders the number of buttons setted by the props
     *
     * @param number [number of buttons to create]
     * @returns React DOM items
     */
    renderButtons = (numberButtons: number) => {
        switch (numberButtons) {
            case 3:
                return (
                    <div>
                        <div
                            className="modal__button modal__button--three modal__button--three__button"
                            onClick={this.actionButton3}
                        >
                            {this.state.thirdButtonText}
                        </div>
                        <div
                            className="modal__button modal__button--three modal__button--three__button"
                            onClick={this.actionButton2}
                        >
                            {this.state.secondaryButtonText}
                        </div>
                        <div
                            className="modal__button modal__button--three"
                            onClick={this.actionButton1}
                        >
                            {this.state.buttonText}
                        </div>
                    </div>
                )

            case 4:
                return (
                    <div>
                        <div
                            className="modal__button modal__button--four modal__button--four__button"
                            onClick={this.actionButton4}
                        >
                            {this.state.fourthButtonText}
                        </div>
                        <div
                            className="modal__button modal__button--four modal__button--four__button"
                            onClick={this.actionButton3}
                        >
                            {this.state.thirdButtonText}
                        </div>
                        <div
                            className="modal__button modal__button--four"
                            onClick={this.actionButton2}
                        >
                            {this.state.secondaryButtonText}
                        </div>
                        <div
                            className="modal__button modal__button--four"
                            onClick={this.actionButton1}
                        >
                            {this.state.buttonText}
                        </div>
                    </div>
                )

            case 2:
                return (
                    <div>
                        <div
                            className="modal__button modal__button--half__left"
                            onClick={this.actionButton2}
                        >
                            {this.state.secondaryButtonText}
                        </div>
                        <div
                            className="modal__button modal__button--half__right"
                            onClick={this.actionButton1}
                        >
                            {this.state.buttonText}
                        </div>
                    </div>
                )

            default:
                return (
                    <div
                        className="modal__button"
                        style={this.state.styles ? this.state.styles.modal__button : null}
                        onClick={this.actionButton1}
                    >
                        {this.state.buttonText}
                    </div>
                )
        }
    }

    render() {
        return (
            <div className={`${(this.state.overlay) ? 'outter_modal' : ''}`}>
                <div className="modal" style={this.state.styles ? this.state.styles.modal : null}>
                    <div
                        className={`modal__title ${(this.state.type) ? 'modal__title--' + this.state.type : ''}
                            ${this.props.className || ''}`}
                    >
                        <h4>
                            {this.state.title}
                        </h4>
                    </div>
                    <div
                        className="modal__description"
                        style={this.state.styles ? this.state.styles.modal__description : null}
                    >
                        {this.state.description}
                    </div>
                    {this.renderButtons(this.state.numberButtons)}
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/PopUp/PopUp.tsx